import { render, staticRenderFns } from "./InvoiceTemplateOptions.vue?vue&type=template&id=5d4dfc87&"
import script from "./InvoiceTemplateOptions.vue?vue&type=script&lang=js&"
export * from "./InvoiceTemplateOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4dfc87')) {
      api.createRecord('5d4dfc87', component.options)
    } else {
      api.reload('5d4dfc87', component.options)
    }
    module.hot.accept("./InvoiceTemplateOptions.vue?vue&type=template&id=5d4dfc87&", function () {
      api.rerender('5d4dfc87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InvoiceTemplateOptions.vue"
export default component.exports